import { Badge } from '@wartek-id/badge'

import type { TPenilaian } from 'types/kinerja-ps'
import type { FC } from 'react'

interface BadgeStatusPengirimanProps {
  status: TPenilaian['statePengiriman']
}

const BadgeStatusPengiriman: FC<BadgeStatusPengirimanProps> = ({
  status = null,
}) => {
  const isSent = status === 'SUDAH_DIKIRIM'
  const label = isSent ? 'Sudah Dikirim' : 'Belum Dikirim'

  if (!status) return <>-</>

  return <Badge variant={isSent ? 'informational' : 'critical'}>{label}</Badge>
}
export default BadgeStatusPengiriman
